import { MarketAdjustmentWritable } from 'api';
import { FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS } from 'pages/FundInvestments/common/constants';
import { getPercentileLabel } from 'pages/ValuationsAllocation/util';
import { GetMarketAdjustmentSelectionParams } from './getMarketAdjustmentSelection.types';

const { percentile_selection_a: PERCENTILE_SELECTION_A, percentile_selection_b: PERCENTILE_SELECTION_B }
  = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const getMarketAdjustmentSelection = (
  params: GetMarketAdjustmentSelectionParams
): MarketAdjustmentWritable.adjustment_selection => {
  const { adjustmentSelection, percentileSelectionA, percentileSelectionB } = params;

  switch (adjustmentSelection) {
    case PERCENTILE_SELECTION_A.title:
      return getPercentileLabel(percentileSelectionA - 1) as MarketAdjustmentWritable.adjustment_selection;

    case PERCENTILE_SELECTION_B.title:
      return getPercentileLabel(percentileSelectionB - 1) as MarketAdjustmentWritable.adjustment_selection;

    default:
      return adjustmentSelection;
  }
};

export default getMarketAdjustmentSelection;
